<template>
  <div id="create">
    <v-container fluid id="anpr-listing-view" class="px-2">
      <v-card elevation="4" color="#EFEBE9" class="px-3 pb-1">
        <v-form v-model="valid">
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                :items="students"
                label="Student"
                item-text="sT_NAME"
                item-value="sT_ID"
                :rules="reqRules"
                required
                outlined
                shaped
                v-model="st_id"
                :loading="loadingStudents"
                ><v-icon slot="prepend-inner" color="primary">
                  mdi-map-marker-outline
                </v-icon>
              </v-autocomplete>
            </v-col>
            <v-col cols="6" md="2">
              <vdate
                label="From Date"
                :rules="reqRules"
                required
                v-model="fromDate"
              >
              </vdate>
            </v-col>
            <v-col cols="6" md="2">
              <vdate
                label="To Date"
                :rules="reqRules"
                required
                v-model="toDate"
              >
              </vdate>
            </v-col>
            <v-col cols="6" md="1">
              <v-btn
                dense
                color="primary"
                @click="showData"
                block
                :disabled="!valid"
                :loading="tableLoading"
                rounded
                x-large
              >
                <v-icon> mdi-database-search </v-icon>
                Search
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
      <v-card elevation="4" color="#EFEBE9" class="px-3 my-5">
        <v-row>
          <v-col cols="12">
            <v-tabs
              v-model="tab"
              background-color="warning"
              dark
              icons-and-text
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab>
                Tabular
                <v-icon>mdi-exclamation-thick</v-icon>
              </v-tab>

              <v-tab @change="graphTab">
                Graphical
                <v-icon>mdi-sticker-check-outline</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" touchless>
              <v-tab-item>
                <v-data-table
                  :mobile-breakpoint="mobilebreakpoint"
                  :headers="headers"
                  :items="listingData"
                  :items-per-page="-1"
                  :search="search"
                  class="elevation-4 mt-2"
                  :footer-props="{
                    itemsPerPageOptions: [10, 20, 40, 80, -1],
                    'items-per-page-text': 'rows/page',
                  }"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                  group-by="suB_NAME"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>

                      <v-btn @click="toggleAll()" fab small color="primary"
                        ><v-icon v-if="!isExpanded">mdi-expand-all</v-icon
                        ><v-icon v-if="isExpanded"
                          >mdi-collapse-all</v-icon
                        ></v-btn
                      >
                    </v-toolbar>
                  </template>
                  <template v-slot:item.eX_DT="{ item }">
                    <span>{{ formatDate(item.eX_DT, "DD-MMM-YY") }}</span>
                  </template>
                  <template v-slot:item.eaM_ATTEND_TYPE="{ item }">
                    <span v-if="item.eaM_ATTEND_TYPE === 'P'">Present</span>
                    <span v-else-if="item.eaM_ATTEND_TYPE === 'A'">Absent</span>
                    <span v-else-if="item.eaM_ATTEND_TYPE === 'L'">Late</span>
                    <span v-else-if="item.eaM_ATTEND_TYPE === 'E'"
                      >Excused</span
                    >
                    <span v-else>Not Processed</span>
                  </template>
                  <template
                    v-slot:group.header="{ group, items, isOpen, toggle }"
                  >
                    <td colspan="3">
                      <v-btn
                        @click="toggle"
                        small
                        icon
                        :ref="group"
                        :data-open="isOpen"
                      >
                        <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                        <v-icon v-else>mdi-chevron-down</v-icon>
                      </v-btn>
                      Subject : {{ group }} ({{ sumSubField("exM_ID", group) }})
                    </td>
                    <td style="text-align: right;">
                      {{ sumSubField("exM_MARKS", group) }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumSubField("eaM_MARKS_OBTAINED", group) }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumSubField("peR_OBTAINED", group) }}
                    </td>
                    <td colspan="3"></td>
                  </template>
                  <template slot="body.append">
                    <td colspan="3" class="py-3 font-weight-black total">
                      <span>Total ({{ sumTotal("exM_ID") }})</span>
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("exM_MARKS") }}
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("eaM_MARKS_OBTAINED") }}
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("peR_OBTAINED") }}
                    </td>
                    <td colspan="3" class="py-3 font-weight-black total"></td>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item eager>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    v-for="item in subjectgroup"
                    :key="item.suB_NAME"
                  >
                    <v-card elevation="4">
                      <livegraph
                        :heading="item.suB_NAME"
                        :subdata="getSubjectwiseData(item.suB_NAME)"
                      >
                      </livegraph>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card elevation="4">
                      <apexchart
                        type="bar"
                        ref="chartb"
                        height="350"
                        :options="chartOptionsb"
                        :series="seriesb"
                      ></apexchart>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card>

      <vconfirm
        :confirmOption="confirmBox"
        @isConfirm="isConfirm"
        :dialogConfirm="dialogConfirm"
        :confirmLoading="confirmLoading"
      >
      </vconfirm>
    </v-container>
  </div>
</template>
<style scoped>
.v-data-table {
  max-width: 100%;
}
.total {
  background-color: lightgray;
  text-align: right;
  padding-right: 1em;
}

.subtotal {
  background-color: yellow;
}
</style>
<script>
import axios from "axios";
import { get, sync } from "vuex-pathify";
import vdate from "@/components/v-date";
import VueApexCharts from "vue-apexcharts";
import vconfirm from "@/components/v-confirm";
import livegraph from "@/components/v-livegraph";
import { formatDate } from "../util/helpers";
import { showSnackbar } from "../util/globalActions";
export default {
  name: "StudentPerformanceView",
  components: { vdate, vconfirm, livegraph, apexchart: VueApexCharts },

  data: () => ({
    seriesb: [
      {
        data: [],
      },
    ],
    loadingStudents: false,
    students: [],
    st_id: "",
    isExpanded: false,
    tab: null,
    validEdit: false,
    switchmobilebreakpoint: false,
    mobilebreakpoint: "200",
    confirmBox: {
      message: "",
      okCaption: "OK",
      cancelCaption: "Cancel",
      data: "",
    },
    dialogConfirm: false,
    confirmLoading: false,
    isConfirm: false,
    width: 700,
    tableLoading: false,
    loadingprofessor: false,
    valid: false,
    modal: false,
    fromDate: null,
    toDate: null,
    search: "",
    listingData: [],
    performanceData: [],
    message: "",
    professors: [],
    snackbar: false,
    reqRules: [(v) => !!v || "Field is required"],
    professor_id: null,
    headers: [],
    subjectgroup: [],
    chartdataInb: [],
    chartcategoriesb: [],
  }),
  created() {
    this.showStudents();
    this.headers = [];
    this.headers.push({
      text: "Date",
      value: "eX_DT",
      width: "120px",
    });
    this.headers.push({
      value: "exM_ID",
      text: "Exam_ID",
      width: "150px",
    });
    this.headers.push({
      value: "eaM_ATTEND_TYPE",
      text: "Attendance",
      width: "100px",
      align: "center",
    });
    this.headers.push({
      value: "exM_MARKS",
      text: "Max Marks",
      width: "100px",
      align: "right",
    });
    this.headers.push({
      value: "eaM_MARKS_OBTAINED",
      text: "Marks Obtd.",
      width: "100px",
      align: "right",
    });
    this.headers.push({
      text: "Percent",
      value: "peR_OBTAINED",
      width: "100px",
      align: "right",
    });
    this.headers.push({
      text: "%Cls Hgh",
      value: "maX_MARKS",
      width: "100px",
      align: "right",
    });
    this.headers.push({
      text: "%Cls Avg",
      value: "avG_MARKS",
      width: "100px",
      align: "right",
    });
    this.headers.push({
      text: "%Cls Low",
      value: "miN_MARKS",
      width: "100px",
      align: "right",
    });
    if (!this.selectedfromdate) {
      this.getDefaultDate();
    } else {
      this.fromDate = new Date(this.selectedfromdate);
      this.toDate = new Date(this.selectedtodate);
      this.showData();
    }
  },
  mounted() {},
  updated() {
    this.closeAll();
  },
  computed: {
    apiUrl: get("app/apiUrl"),
    userid: get("user/id"),
    menuid: get("user/menuid"),
    selectedfromdate: sync("app/performancefromdate"),
    calenderselecteddate: get("app/calenderselecteddate"),
    fromDashboard: sync("app/fromDashboard"),
    selectedtodate: sync("app/performancetodate"),
    selecteduserid: get("app/selecteduserid"),
    chartOptionsb: function() {
      return {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: true,
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return (
              "<table><tr><th>" +
              w.globals.labels[dataPointIndex] +
              '</th></tr><tr><td style="text-align: center;"><span>' +
              series[seriesIndex][dataPointIndex] +
              "</span>" +
              "</td></tr></table>"
            );
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          title: {
            text: "Percentage",
          },
        },
      };
    },
  },
  watch: {
    switchmobilebreakpoint: function(value) {
      if (value === true) this.mobilebreakpoint = "600";
      else this.mobilebreakpoint = "200";
    },
  },
  methods: {
    formatDate,
    getParameter() {
      const self = this;
      const fromDate = new Date(self.fromDate).toJSON();
      const toDate = new Date(self.toDate).toJSON();
      const data = {
        fromDate: fromDate,
        uptoDate: toDate,
        ST_ID: this.st_id,
        Dashboard: "N",
      };
      return data;
    },
    getDefaultDate() {
      const self = this;
      axios({
        url: self.apiUrl + "api/Common/getAcademicToday",

        method: "GET",
        responseType: "json",
      }).then(function(response) {
        self.fromDate = formatDate(new Date(response.data.fromDate),"YYYY-MM-DD"
        );
        self.toDate = formatDate(new Date(response.data.toDate),"YYYY-MM-DD"
        );

        self.showData();
      });
    },

    showData() {
      const self = this;
      self.selectedfromdate = self.fromDate;
      self.selectedtodate = self.toDate;

      self.tableLoading = true;
      const data = self.getParameter();

      axios({
        url: self.apiUrl + "api/Performance/performance",
        data: data,
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          
          self.listingData = res.data.utr7_performanceMail1;
          
          self.subjectgroup = self.findUnique(
            self.listingData,
            (d) => d.suB_NAME
          );
          self.tableLoading = false;
          //self.hiddenPDF = false;
        })
        .catch(function(err) {
          //self.hiddenPDF = true;
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
    showStudents() {
      const self = this;
      self.loadingStudents = true;

      axios({
        url: self.apiUrl + "api/Common/GetStudents",
        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          self.students = res.data;
          self.loadingStudents = false;
        })
        .catch(function(err) {
          self.loadingStudents = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },

    graphTab() {
      const self = this;
      self.selectedfromdate = self.fromDate;
      self.selectedtodate = self.toDate;

      self.tableLoading = true;
      const data = self.getParameter();

      axios({
        url: self.apiUrl + "api/Performance/dashboardperformance",
        data: data,
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          //self.performanceData = res.data;
          
          self.seriesb = [];
          res.data.forEach((element) => {
            //percentage = element.averageP;
            self.chartdataInb.push(element.peR_OBTAINED);

            self.chartcategoriesb.push(element.suB_NAME);
          });
          self.seriesb.push({ data: self.chartdataInb });
          
          if (self.chartcategoriesb.length > 0) {
            self.$refs.chartb.updateOptions({
              xaxis: {
                categories: self.chartcategoriesb,
              },
            });
          }
          self.tableLoading = false;
          //self.chartOptionsb.xaxis.categories = self.chartcategories;
        })
        .catch(function(err) {
          self.tableLoading = false;
          self.message = err.status;
          console.log(err);
          showSnackbar({ message: "Performance data not found!" });
        });
    },
    findUnique(arr, predicate) {
      var found = {};
      arr.forEach((d) => {
        found[predicate(d)] = d;
      });
      return Object.keys(found).map((key) => found[key]);
    },
    getSubjectwiseData(subject) {
      const subedtData = this.listingData.filter(
        (item) => item.suB_NAME === subject
      );
      return subedtData;
    },
    row_classes(item) {
      return item.rowcolor.toLowerCase();
    },

    sumSubField(key, subject) {
      // sum data in give key (property)
      const subjectgroup = this.listingData.filter(
        (item) => item.suB_NAME === subject
      );
      const avgper = subjectgroup.filter(
          (item) => item.eaM_ATTEND_TYPE === "P" || item.eaM_ATTEND_TYPE === "L"
        );
      if (key === "peR_OBTAINED") {
        const total = avgper.reduce((a, b) => a + (b["exM_MARKS"] || 0), 0);
        const gettotal = avgper.reduce(
          (a, b) => a + (b["eaM_MARKS_OBTAINED"] || 0),
          0
        );
        if (total > 0) return ((gettotal * 100) / total).toFixed(0);
        else return 0;
      } else if (key === "exM_ID") return avgper.length;
      return avgper.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumTotal(key) {
      // sum data in give key (property)
      const subjectgroup = this.listingData;
      const avgper = subjectgroup.filter(
          (item) => item.eaM_ATTEND_TYPE === "P" || item.eaM_ATTEND_TYPE === "L"
        );
      if (key === "peR_OBTAINED") {
        const total = avgper.reduce((a, b) => a + (b["exM_MARKS"] || 0), 0);
        const gettotal = avgper.reduce(
          (a, b) => a + (b["eaM_MARKS_OBTAINED"] || 0),
          0
        );
        if (total > 0) return ((gettotal * 100) / total).toFixed(0);
        else return 0;
      } else if (key === "exM_ID") return avgper.length;
      return avgper.reduce((a, b) => a + (b[key] || 0), 0);
    },
    toggleAll() {
      if (this.isExpanded) this.closeAll();
      else this.openAll();
    },
    closeAll() {
      this.isExpanded = false;
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
    openAll() {
      this.isExpanded = true;
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && !this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
  },
  beforeDestroy() {
    this.fromDashboard = null;
  },
};
</script>
